import { render, staticRenderFns } from "./orderSee.vue?vue&type=template&id=1533b988&scoped=true&"
import script from "./orderSee.vue?vue&type=script&lang=js&"
export * from "./orderSee.vue?vue&type=script&lang=js&"
import style0 from "./orderSee.vue?vue&type=style&index=0&id=1533b988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533b988",
  null
  
)

export default component.exports